import { Checkbox } from '@mui/material';
import React, { FC } from 'react';
import { TypographyStyledGlobal } from '../../../theme';
import { SurveyModalProps } from './addSurveyInterface';
import { CardSurveyStyled } from './styled';

const SurveyModal: FC<SurveyModalProps> = ({
    survey, selectedSurveyId, handleSelectedSurvey,
}) => {
    const handleChange = () => {
        handleSelectedSurvey(survey);
    };

    return (
        <CardSurveyStyled
            $surveychecked={survey.id === selectedSurveyId}
            control={<Checkbox />}
            label={(
                <TypographyStyledGlobal
                    margin='0px 0px 4px 0px'
                    sx={{ color: 'black', fontSize: '14px' }}
                    weight='500'
                >
                    {survey.description}
                </TypographyStyledGlobal>
            )}
            onChange={handleChange}
        />
    );
};

export default SurveyModal;
